export const RECEIPT_PRODUCT_SALE = 'SALE'
export const RECEIPT_PRODUCT_SAMPLE = 'SAMPLE'

export const Types = [
  {
    code: RECEIPT_PRODUCT_SALE,
    label: 'Sale'
  },
  {
    code: RECEIPT_PRODUCT_SAMPLE,
    label: 'Sample'
  }
]

export function getLabel (code) {
  return _.get(Types.find((x) => x.code === code), 'label')
}

export default Types
